import { ApiService } from "./ApiService"

export class ProfileService {

    static uri = '/profile';

    // Method GET Data
    static get() {
        return ApiService.get(`${this.uri}`, 
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                }
            }
        );
    }

    // Method UPDATE (Sudah ada sebelumnya)
    static update({ data }) {
        return ApiService.post(`${this.uri}/update`, data,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }

    static updateCompanyProfile({ data }) {
        return ApiService.post(`${this.uri}/update/company-profile`, data,
            {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
    }
}